module.exports = __webpack_public_path__ + "img/logo.798cf6cf.png";